import React, { useEffect, useRef } from "react"
import { useNavigate } from "react-router"
import { useDispatch, useSelector } from "react-redux"
import { Button, Form, Input, Select, Col } from "antd"

// Constants
import { 
    ROUTES, 
    COMMON_FEATURES 
} from '../../../../constants'

// Components
import showSecondarySidebar from "../../../../layout/MainLayout/helpers/showSecondarySidebar"
import Page from "../../../../components/Decoration/Page"

// Services Library
import { REDUX } from "../../../../services/util"

// Redux Actions
import * as REDUX_ACTIONS from '../../../../services/redux/actions'

// Style
import styles from '../../../VehicleManagement/modules/index.module.css'

const DeviceCUForm = ({
    data = {}
}) => {

    const prevPathname = data?.prevPathname
    const title = data?.title || 'Create'
    const subtitle = prevPathname === ROUTES.MODULE_ROUTE[COMMON_FEATURES.FEATURE_NAME.GPS_MANAGEMENT] ? 'Device' : 'MDVR'

    const dispatch = useDispatch()
    const navigate = useNavigate()

    const [ form ] = Form.useForm()

    const { uid, hierCode } = useSelector(REDUX.reduxStoreWrapper('user'))
    const users = useSelector(REDUX.reduxStoreWrapper('userHierarchy.byID'))
    const models = useSelector(REDUX.reduxStoreWrapper('devices.modelByDEVMID'))

    const userOptions = Object.values(users)
    // .filter(u => u.uroleid === 'D' || u.uroleid === 'S' || u.uroleid === 'A' )
    .filter(u => (u.uroleid || '').includes('D') || (u.uroleid === 'A'))
    .map(u => ({
        label: u.name,
        value: u.uid
    }))

    // Load device/users
    const isLoad = useRef(false)
    const userHierarchyTree = useSelector(state => state.containers.v3.userHierarchy.hierarchyTree)
    const user = useSelector(state => state.containers.v3.user)

    useEffect(() => {
        if(uid && !isLoad.current && !Object.keys(userHierarchyTree).length) {
            dispatch(REDUX_ACTIONS.v3_userHierarchy.user_hierarchy_get_request(user, hierCode))
            isLoad.current = true
        }
    }, [uid])

    const modelOptions = prevPathname === ROUTES.MODULE_ROUTE[COMMON_FEATURES.FEATURE_NAME.GPS_MANAGEMENT] ? Object.keys(models).map(m => ({
        value: m,
        label: m
    })) 
    :
    [ { value: 'DV454', label: 'DV454' } ] 

    useEffect(() => {
        dispatch(REDUX_ACTIONS.v3_devices.get_device_model_request())
    }, [])

    const onFinish = (e) => {

        switch(title) {
            case 'Create': {
                if(prevPathname === ROUTES.MODULE_ROUTE[COMMON_FEATURES.FEATURE_NAME.MDVR_MANAGEMENT]) {
                    dispatch(REDUX_ACTIONS.v3_devicesMDVR.create_device_mdvr_request({
                        dvid: data.dvid,
                        device: { 
                            dvid: data.dvid,
                            imei: e.imei,
                            brand: e.brand,
                            devmid: e.devmid,
                            simContact: e.simContact,
                            iccid: e.iccid
                        },
                        uid,
                        vid: data.vid,
                        company: e.company,
    
                    }, () => {
                        navigate(-1)
                    }))
                }
                else if(prevPathname === ROUTES.MODULE_ROUTE[COMMON_FEATURES.FEATURE_NAME.GPS_MANAGEMENT]) {
                    dispatch(REDUX_ACTIONS.v3_devices.create_device_request({
                        dvid: data.dvid,
                        device: { 
                            dvid: data.dvid,
                            imei: e.imei,
                            brand: e.brand,
                            devmid: e.devmid,
                            simContact: e.simContact,
                            iccid: e.iccid
                        },
                        uid,
                        vid: data.vid,
                        company: e.company,
    
                        // contact: Number(e.contact)
    
                    }, () => {
                        // navigate(`/management/device`)
                        navigate(-1)
                    }))
                }

                break;
            }

            case 'Edit': {
                if(prevPathname === ROUTES.MODULE_ROUTE[COMMON_FEATURES.FEATURE_NAME.MDVR_MANAGEMENT]) {
                    dispatch(REDUX_ACTIONS.v3_devicesMDVR.update_device_mdvr_request({
                        // dvid: data.mdvrid,
                        mdvrid: data.mdvrid,
                        simContact: e.simContact,
                        vid: data.vid,
                        uid,
                        company: e.company,
                        status: data.status || 0,
                        iccid: e.iccid
                        // contact: Number(e.contact)
                    }, () => {
                        // navigate(`/management/device`)
                        navigate(-1)
                    }))
                } else {
                    dispatch(REDUX_ACTIONS.v3_devices.update_device_request({
                        dvid: data.dvid,
                        simContact: e.simContact,
                        vid: data.vid,
                        uid,
                        company: e.company,
                        status: data.status || 0,
                        iccid: e.iccid
                        // contact: Number(e.contact)
                    }, () => {
                        // navigate(`/management/device`)
                        navigate(-1)
                    }))
                }
            }
        }
    }

    return (
        <div className="page-container">
            <Page title={`${title} ${subtitle}`}>
                <Form 
                    style={{ width: '50vw', minWidth: '60em', margin: '5em auto'}}
                    labelCol={{ span: 6 }}
                    form={form}
                    onFinish={onFinish}
                    initialValues={{
                        ...data,
                        imei: data?.dvid?.split('#')[1] || data.mdvrid,
                        devmid: data?.model || data?.devmid || '',
                        brand: (prevPathname === ROUTES.MODULE_ROUTE[COMMON_FEATURES.FEATURE_NAME.GPS_MANAGEMENT] ? data?.brand || '' : 'Stonkam').toUpperCase()
                    }}
                >
                    <Col className="subtitle">
                        <span>Device Information</span>
                    </Col>
                    <Form.Item
                        label="Device IMEI"
                        name="imei"
                        rules={[
                            {
                                required: true,
                                message: 'Please input device imei!',
                            },
                            {
                                pattern: /^\d+$/,
                                message: 'Please input only number'
                            }
                        ]}
                        >
                            <Input disabled={data.dvid || data.imei ? true : false} size="large" />
                    </Form.Item>
                    <Form.Item
                        label="Device Model"
                        name="devmid"
                        // rules={[
                        //     {
                        //         required: true,
                        //         message: 'Please input device model!',
                        //     },
                        // ]}
                    >
                        <Select options={modelOptions} disabled={data.model ? true : false} onChange={e => (prevPathname === ROUTES.MODULE_ROUTE[COMMON_FEATURES.FEATURE_NAME.GPS_MANAGEMENT]) && form.setFieldsValue({ brand: (models[e]?.brand || '').toUpperCase() })} size="large" />
                    </Form.Item>
                    <Form.Item
                            label="Device Brand"
                            name="brand"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please input device brand!',
                                },
                            ]}
                            >
                                <Input 
                                    disabled={data.model ? true : false} 
                                    size="large" 
                                    onChange={(e) => {
                                        if(prevPathname === ROUTES.MODULE_ROUTE[COMMON_FEATURES.FEATURE_NAME.GPS_MANAGEMENT]) {
                                            const upper = e.target.value.toUpperCase();
                                            form.setFieldsValue({ brand: upper });
                                        }
                                    }}
                                />
                    </Form.Item>
                    <Form.Item
                        label="Assigned User"
                        name="company"
                        rules={[
                            {
                                required: true,
                                message: 'Please select assigned user!',
                            },
                        ]}
                    >
                        <Select size="large" options={userOptions} />
                    </Form.Item>

                    <Col className="subtitle">
                        <span>SIM Card Information</span>
                    </Col>
                    <Form.Item
                        label="Mobile Number"
                        name="simContact"
                        rules={[
                            {
                                required: true,
                                message: 'Please input mobile number!',
                            },
                            // {
                            //     // pattern: /^(?:\+60|60|0)(?:1[0-46-9][0-9]{7,8}|[3-9][0-9]{7,8})$/,
                            //     pattern: /^(?:\+60|60|0)\d{2,4}-?\d{3,4}-?\d{3,4}$/,
                            //     message: 'Invalid mobile number format. Please enter a valid mobile number!'

                            // }
                        ]}
                        >
                            <Input size="large" />
                    </Form.Item>
                    <Form.Item
                        label="SIM Serial Number (ICCID)"
                        name="iccid"
                        // rules={[
                        //     {
                        //         required: true,
                        //         message: 'Please input SIM serial number!',
                        //     },
                        // ]}
                        >
                            <Input size="large" />
                    </Form.Item>

                        <div className={styles['button-container']}>
                            <Button className={`${styles['button']} ${styles['cancel']}`} onClick={() => navigate(-1)}>Cancel</Button>
                            <Button className={`${styles['button']} ${styles['add']}`} htmlType="submit">{title === 'Create' ? 'Add' : 'Save'}</Button>
                        </div>
                </Form>
            </Page>
        </div>
    )
}

const MemoizedDeviceCUForm = React.memo(DeviceCUForm);

export default showSecondarySidebar(false)(MemoizedDeviceCUForm);